import { cn } from "../lib/utils";
import imzLogo from "../assets/brand/imz-logo.png";
import bsnlLogo from "../assets/brand/bsnl-logo.png";

// White rounded chip keeps both brand logos crisp and legible on the dark kiosk UI.
export function ImzLogo({ className }) {
  return (
    <span
      className={cn("inline-flex items-center justify-center rounded-xl bg-white px-3 py-2 shadow-md ring-1 ring-black/5 no-select", className)}
      data-testid="imz-logo"
    >
      <img src={imzLogo} alt="IMZ Corporate Pvt. Ltd." className="h-9 sm:h-11 w-auto object-contain" />
    </span>
  );
}

export function BsnlLogo({ className }) {
  return (
    <span
      className={cn("inline-flex items-center justify-center rounded-xl bg-white px-3 py-2 shadow-md ring-1 ring-black/5 no-select", className)}
      data-testid="bsnl-logo"
    >
      <img src={bsnlLogo} alt="BSNL Connecting Bharat" className="h-9 sm:h-11 w-auto object-contain" />
    </span>
  );
}

// BSNL first, then IMZ.
export function CoBrand({ className }) {
  return (
    <div className={cn("flex items-center gap-3", className)}>
      <BsnlLogo />
      <span className="h-8 w-px bg-cyan-400/25" />
      <ImzLogo />
    </div>
  );
}
